module.exports = __webpack_public_path__ + "images/createListImage.63e2347d.svg";